import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon, StarIcon } from 'lucide-react';
const buyers = [{
  name: 'Lucas M.',
  city: 'Buenos Aires'
}, {
  name: 'Diego R.',
  city: 'Córdoba'
}, {
  name: 'Fabián S.',
  city: 'Rosario'
}, {
  name: 'Martín L.',
  city: 'Mendoza'
}, {
  name: 'Javier P.',
  city: 'La Plata'
}, {
  name: 'Carlos G.',
  city: 'Tucumán'
}, {
  name: 'Nicolás F.',
  city: 'Mar del Plata'
}, {
  name: 'Sebastián D.',
  city: 'Salta'
}, {
  name: 'Matías V.',
  city: 'Santa Fe'
}, {
  name: 'Pablo H.',
  city: 'Neuquén'
}, {
  name: 'Fernando C.',
  city: 'Lanús'
}, {
  name: 'Rodrigo B.',
  city: 'San Juan'
}, {
  name: 'Gustavo T.',
  city: 'Quilmes'
}, {
  name: 'Alejandro N.',
  city: 'Paraná'
}, {
  name: 'Ezequiel M.',
  city: 'Bahía Blanca'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState(buyers[0]);
  useEffect(() => {
    const initialTimer = setTimeout(() => {
      showNextPopup();
    }, 5000);
    return () => clearTimeout(initialTimer);
  }, []);
  const showNextPopup = () => {
    const randomBuyer = buyers[Math.floor(Math.random() * buyers.length)];
    setCurrentBuyer(randomBuyer);
    setIsVisible(true);
    setTimeout(() => {
      setIsVisible(false);
      const nextInterval = Math.floor(Math.random() * (12000 - 8000 + 1) + 8000);
      setTimeout(showNextPopup, nextInterval);
    }, 5000);
  };
  return <AnimatePresence data-id="element-289">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 25
    }} className="fixed bottom-4 left-4 z-50 max-w-sm w-[calc(100%-2rem)] bg-white rounded-xl shadow-2xl border border-gray-100 p-4 flex items-center gap-4" data-id="element-290">
          <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600" data-id="element-291">
            <XIcon className="w-4 h-4" data-id="element-292" />
          </button>

          <div className="w-12 h-12 bg-brand-ice rounded-full flex items-center justify-center flex-shrink-0 border border-brand-secondary" data-id="element-293">
            <span className="text-2xl" data-id="element-294">❄️</span>
          </div>

          <div data-id="element-295">
            <p className="text-sm text-gray-800" data-id="element-296">
              <span className="font-bold" data-id="element-297">{currentBuyer.name}</span> de{' '}
              {currentBuyer.city}
            </p>
            <p className="text-xs font-bold text-brand-primary mt-1" data-id="element-298">
              ¡Acaba de comprar su Pack!
            </p>
            <div className="flex items-center gap-1 mt-1.5" data-id="element-299">
              <StarIcon className="w-3.5 h-3.5 text-yellow-400 fill-current" data-id="element-300" />
              <span className="text-[11px] font-bold text-brand-green uppercase tracking-wide" data-id="element-301">
                Compra verificada
              </span>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}